export default __webpack_public_path__ + "static/media/logo.73fe07c7.png";